import React from 'react';
// import { DownOutlined } from '@ant-design/icons';
import ScrollElement from 'rc-scroll-anim/lib/ScrollElement';
import QueueAnim from 'rc-queue-anim';
// import TweenOne, { TweenOneGroup } from 'rc-tween-one';
import { TweenOneGroup } from 'rc-tween-one';
import BannerAnim, { Element } from 'rc-banner-anim';
import { useOutletContext } from 'react-router-dom';
// import { isImg } from '@/utils';
import 'rc-banner-anim/assets/index.css';
import { useTranslation } from 'react-i18next';

const { BgElement } = Element;
const Banner = (props) => {
  const { dataSource, ...restProps } = props;
  const { i18n } = useTranslation();
  const { onEnterChange } = useOutletContext();

  const childrenToRender = dataSource.BannerAnim.children.map((item, i) => {
    const elem = item.BannerElement;
    const elemClassName = elem.className;
    delete elem.className;
    const { bg, textWrapper } = item;
    return (
      <Element key={i.toString()} {...elem} prefixCls={elemClassName}>
        <BgElement
          key="bg"
          {...bg}
          style={{ backgroundImage: `url(${require(`@/assets/home/banner${(i + 1)}${i18n.language === 'en' ? '_en' : ''}.png`)})` }} />
        <QueueAnim
          type={['bottom', 'top']}
          delay={200}
          key="text"
          {...textWrapper}
        >
          {/*<div key="content" {...content}>*/}
          {/*  {t(content.children)}*/}
          {/*</div>*/}
          {/*<div key="logo" {...title}>*/}
          {/*  {typeof title.children === 'string' &&*/}
          {/*  title.children.match(isImg) ? (*/}
          {/*    <img src={title.children} width="100%" alt="img" />*/}
          {/*  ) :  t(title.children)*/}
          {/*  }*/}
          {/*</div>*/}
        </QueueAnim>
      </Element>
    );
  });

  return (
    <div {...restProps} {...dataSource.wrapper}>
      <ScrollElement
        className="page"
        id="banner"
        onChange={({ mode }) => {
          console.log('mode', mode);
          onEnterChange(mode);
        }}
        playScale={0.9}
      >
        <TweenOneGroup
          key="bannerGroup"
          enter={{ opacity: 0, type: 'from' }}
          leave={{ opacity: 0 }}
          component=""
        >
          <div className="banner1-wrapper" key="wrapper">
            <BannerAnim key="BannerAnim" {...dataSource.BannerAnim} type={'across'} autoPlay>
              {childrenToRender}
            </BannerAnim>
          </div>
        </TweenOneGroup>
        {/*<TweenOne*/}
        {/*  animation={{*/}
        {/*    y: '-=20',*/}
        {/*    yoyo: true,*/}
        {/*    repeat: -1,*/}
        {/*    duration: 1000,*/}
        {/*  }}*/}
        {/*  className="banner1-icon"*/}
        {/*  style={{ bottom: 40 }}*/}
        {/*  key="icon"*/}
        {/*>*/}
        {/*  <DownOutlined />*/}
        {/*</TweenOne>*/}
      </ScrollElement>
    </div>
  );
};

export default Banner;
